
import { computed } from '@vue/composition-api';
import CartProduct from '~/components/CartProduct/CartProduct.vue';
import type { CartProduct as CartProductType } from '~/type/product/Product';
const __sfc_main = {};
__sfc_main.props = {
  products: {
    key: "products",
    required: true,
    type: Array
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const innerList = computed(() => {
    return props.products.reduce<{
      available: CartProductType[];
      notAvailable: CartProductType[];
      preOrder: CartProductType[];
    }>((acc, p) => {
      switch (p.status?.code) {
        case 'NOT_AVAILABLE':
          acc.notAvailable.push(p);
          break;
        case 'PRE_ORDER':
          acc.preOrder.push(p);
          break;
        default:
          acc.available.push(p);
      }
      return acc;
    }, {
      available: [],
      notAvailable: [],
      preOrder: []
    });
  });
  const unavailableIds = computed(() => innerList.value.notAvailable.map(p => p.id));
  return {
    emit,
    innerList,
    unavailableIds
  };
};
__sfc_main.components = Object.assign({
  CartProduct
}, __sfc_main.components);
export default __sfc_main;
